module.exports = "/images/vendor/flag-icon-css/flags/1x1/eu.svg?4c73f57cb89b48ebae5e4d8be33e83b8";